import bodymovin from "lottie-web";

export default class VisualTools {
    constructor() {
        this.addEvents();
    }

    addEvents() {
        let pageGlobal = 1;

        let filterAjax = {
            page: 1,
            cat: '',
            daf: '',
            masechet: '',
            input: '',
            sort: 'date',
            lang: $('html').attr('lang') == 'he-IL' ? 'he' : 'en'
        }


        $('.visual_tools__input input').keypress(function (e) {
            if(e.which == 13){
                let val = $(this).val();
                pageGlobal = 1;
                filterAjax.input = val;
                getAjax();
            }
        });


        $('.visual_tools__cat--item').on('click',function (e){
            $('.visual_tools__cat--item').removeClass('active');
            $(this).addClass('active');
            filterAjax.cat = $(this).attr('data-tax') != 'all' ? $(this).attr('data-tax') : '';
            filterAjax.page = 1;
            getAjax();
        })

        if($('div').hasClass('visual_tools__list')){
            $('.post-paginate__sort--item').on('click', function (e){
                filterAjax.sort = $(this).index() + 1;
                filterAjax.page = 1;
                getAjax();
            })

            $('.visual_tools__masechet .search__select--list>div').on('click', function (e){
                filterAjax.masechet = $(this).attr('data-tax');
                filterAjax.page = 1;
                getAjax();
            })
            $('.visual_tools__masechet .search__select--remove').on('click', function (e){
                filterAjax.masechet = '';
                filterAjax.page = 1;
                getAjax();
            })

        }

        $('.post-paginate__pagination').on('click', '.page-numbers:not(.prev):not(.next)', function (e){
            e.preventDefault();
            filterAjax.page = $(this).text();
            pageGlobal = $(this).text();
            getAjax();
        })

        $('.post-paginate__pagination').on('click', '.next', function (e){
            e.preventDefault();
            filterAjax.page = parseInt(pageGlobal)+1;
            pageGlobal = parseInt(pageGlobal)+1;
            getAjax();
        })

        $('.post-paginate__pagination').on('click', '.prev', function (e){
            e.preventDefault();
            filterAjax.page = parseInt(pageGlobal)-1;
            pageGlobal = parseInt(pageGlobal)-1;
            getAjax();
        })

        $('.visual_tools__cat--head').on('click', function (e){
            $('.visual_tools__cat').toggleClass('close');
        })

        function addAnimation(){
            const animatedImages = document.querySelectorAll(
                '.visual_tools__item--bottom .animation-container'
            );

            [...animatedImages].forEach((el) => {
                const staticImage = el.querySelector('.animation-image');

                if(el.querySelectorAll('.animation-container svg').length >	 1 || el.querySelectorAll('.animation-container.follow-ajax svg').length >= 1
                    || el.querySelectorAll('.animation-container.register-popup svg').length >= 1){
                    return;
                }

                let animationClassName = null;
                if (staticImage) {
                    animationClassName = [...staticImage.classList].find((className) => {
                        if (className.startsWith('animation-image-')) {
                            return true;
                        }
                    });
                }

                if(!animationClassName){
                    return
                }

                const animationName = animationClassName.replace('animation-image-', '');

                const animationItem = bodymovin.loadAnimation({
                    container: el,
                    animType: 'svg',
                    loop: false,
                    autoplay: false,
                    path: AssetsPath.url + `/animations/${animationName}.json`,
                });

                if (staticImage) {
                    staticImage.classList.add('hidden');
                }

                el.addEventListener('mouseenter', function () {
                    animationItem.goToAndStop(0, true);
                    animationItem.play();
                });

                el.addEventListener('complete', function () {
                    animationItem.goToAndStop(0, true);
                });
            });
        }

        function getAjax() {
            var ajaxurl = myAjax.ajaxurl;
            $.ajax({
                type: "POST",
                url: ajaxurl,
                data: {
                    "action": "get_element_visual",
                    filterAjax
                },
                success: function (result) {
                    let results = result;
                    if (results && results.items) {
                        $('.visual_tools__list').html('');
                        $('.post-paginate__pagination').html(results.pagination);
                        $('.post-paginate__count i, .visual_tools__pagination i').html(results.total);
                        $('.post-paginate__count span, .visual_tools__pagination span').html(results.current);
                        $.each(results.items, function (i,e){
                            $(this).appendTo('.visual_tools__list');
                        })
                        addAnimation();
                    }
                }
            })
        }
    }
}